<template>
  <div>
    <v-dialog v-model="showModal" persistent scrollable max-width="500">
      <v-card>
        <v-card-title class="headline">
          <v-layout align-center>
            <v-flex xs6>
              Excel Upload
            </v-flex>
            <v-flex xs6 class="text-sm-right">
              <v-btn :href="urlDownloadExcel" target="_blank"> Download format </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="Search file"
            readonly
            @click="pickFile"
            v-model="excelName"
            prepend-icon="attach_file"
            v-validate="'required'"
            :error-messages="errors.collect('excelName')"
            data-vv-name="file excel"
          > </v-text-field>
          <input
            type="file"
            style="display: none"
            ref="excelInput"
            accept=".xlsx"
            @change="onFilePicked"
          >
          <v-switch
            v-model="mode"
            :label="`Mode: ${mode ? 'Duplicate' : 'Update'}`"
          > </v-switch>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            :disabled="loading"
            @click="closeModalUploadContacts"
          > Close </v-btn>
          <v-btn
            color="primary"
            :disabled="loading"
            @click="uploadExcel"
          > Upload file </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { mapGetters, mapActions } from 'vuex';

export default {
  
  props: {
    roundId: {
      type: String,
      required: false
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      excelName: '',
      mode: false,
      excelFile: null,
      urlDownloadExcel: window.axios.defaults.baseURL + '/download-excel-format',
      loading: false
    };
  },
  computed: {
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    clearExcel () {
      this.$refs.excelInput.value = '';
      this.excelFile = '';
      this.excelName = '';
      this.mode = false;
    },
    closeModalUploadContacts () {
      this.$emit('close-modal-upload-contacts');
      this.clearExcel();
    },
    uploadExcel () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.excelFile) {
            this.loading = true;
            this.setLoading(true);
            let modeText = this.mode ? 'duplicate' : 'update';
            let url = `rounds/upload-contacts`;

            let formData = new FormData();
            formData.append('file', this.excelFile);
            formData.append('mode', modeText);
            formData.append('round_id', this.roundId);

            window.axios.post(url, formData).then(response => {
              this.setSnackbar({
                show: true,
                color: 'success',
                text: 'Contacts imported correctly.'
              });
              localStorage.setItem('reference', response.data.reference);

              this.closeModalUploadContacts();
              this.$emit('show-loading-upload');
              this.loading = false;
              this.setLoading(false);
            }).catch(error => {
              this.loading = false;
              this.setLoading(false);
            });
          } else {
            this.setLoading(false);
            this.loading = false;
            this.setSnackbar({
              show: true,
              color: 'error',
              text: 'File not valid.'
            });
          }
        } else {
          this.setLoading(false);
          this.setSnackbar({
            show: true,
            color: 'error',
            text: 'File not valid.'
          });
        }
      });
    },
    pickFile () {
      this.$refs.excelInput.click();
    },
    onFilePicked (e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.excelName = files[0].name;
        if (this.excelName.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.excelFile = files[0];
        });
      } else {
        this.excelName = '';
        this.excelFile = '';
      }
    }
  }
};
</script>
<style lang="css">
  .bg-success{
    padding: 6px 8px;
    background-color: #FFEE58;
    font-size: 1.2rem;
    font-weight: bold;
    color: #fff;
  }
  .bg-green{
    background-color: #43A047;
  }
  .table-info{
    margin-top: 1rem;
    width: 100%;
  }
  .table-info th{
    text-align: left;
    font-size: 1.2rem;
  }
  .table-info td, .table-info th{
    padding: 6px 8px;
    border-bottom: 1px solid rgba(0, 0, 0, .1);
  }
  .table-info tr:last-of-type td{
    border: none;
  }
  .text-title{
    font-size: 1.2rem;
  }
  .header-error .v-expansion-panel__header{
    background-color: #E53935;
    color: #fff;
  }
  .header-created .v-expansion-panel__header{
    background-color: #8BC34A;
    color: #fff;
  }
  .header-updated .v-expansion-panel__header{
    background-color: #1E88E5;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/contacts/components/modals/UploadExcel.vue